import React from 'react';
import './Documents.css';
import './Overview.css';

const Documents = () => {
  const documents = [
    { id: 1, category: 'COMPANY', name: 'Certificate of Incorporation', status: 'VERIFIED', statusClass: 'verified' },
    { id: 2, category: 'COMPANY', name: 'Udyam (MSME) Registration', status: 'VERIFIED', statusClass: 'verified' },
    { id: 3, category: 'FOUNDER', name: 'PAN & Aadhaar Copy — Rimal Katodia', status: 'VERIFIED', statusClass: 'verified' },
    { id: 4, category: 'BUSINESS', name: 'Pitch Deck', status: 'UPLOADED - REVIEW', statusClass: 'uploaded' },
    { id: 5, category: 'FINANCIAL', name: 'Financial Projections (3-5 yr)', status: 'NOT UPLOADED', statusClass: 'not-uploaded' },
    { id: 6, category: 'FINANCIAL', name: 'Bank Details & Cancelled Cheque', status: 'NOT UPLOADED', statusClass: 'not-uploaded' },
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title">
          <h1>Document Checklist</h1>
          <div className="page-meta">7 of 10 verified</div>
        </div>
      </div>

      <div className="card">
        {documents.map((doc) => (
          <div className="doc-list-item" key={doc.id}>
            <div className="doc-info">
              <span className="doc-category">{doc.category}</span>
              <span className="doc-name">{doc.name}</span>
            </div>
            <div className={`status-badge ${doc.statusClass}`}>
              {doc.status}
            </div>
          </div>
        ))}

        <button className="upload-btn">Upload document</button>
      </div>
    </div>
  );
};

export default Documents;
